module.exports = __webpack_public_path__ + "static/media/coverimage.cb75fccb.jpg";